import { useRef } from "react";
import { Box, Typography, CircularProgress, Slide } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";

const STATUS_CONFIG = {
  submitting: {
    bg: "#0E7C86",
    ring: "rgba(14,124,134,0.25)",
    text: "Submitting swap…",
    icon: <CircularProgress size={22} thickness={5} sx={{ color: "#fff" }} />,
  },
  success: {
    bg: "#027A48",
    ring: "rgba(2,122,72,0.25)",
    text: "Swap submitted",
    icon: <CheckCircleRoundedIcon sx={{ fontSize: 24, color: "#fff" }} />,
  },
  failed: {
    bg: "#B42318",
    ring: "rgba(180,35,24,0.25)",
    text: "Auto-submit failed. Submit the swap manually.",
    icon: <ErrorRoundedIcon sx={{ fontSize: 24, color: "#fff" }} />,
  },
};

export default function AutoSubmitToast({ status }) {
  const lastConfig = useRef(null);
  const config = STATUS_CONFIG[status];
  if (config) lastConfig.current = config;
  const view = config || lastConfig.current;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 32,
        left: 0,
        right: 0,
        zIndex: 2000,
        display: "flex",
        justifyContent: "center",
        px: 2,
        pointerEvents: "none",
      }}
    >
      <Slide direction="down" in={Boolean(config)} mountOnEnter unmountOnExit>
        <Box
          role="status"
          aria-live="polite"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            maxWidth: "100%",
            minWidth: { xs: 0, sm: 280 },
            px: 3,
            py: 1.75,
            borderRadius: "16px",
            bgcolor: view?.bg,
            boxShadow: `0 0 0 6px ${view?.ring}, 0 20px 40px -8px rgba(16,24,40,0.35), 0 4px 10px rgba(16,24,40,0.2)`,
            transition: "background-color .2s ease, box-shadow .2s ease",
            pointerEvents: "auto",
          }}
        >
          {view?.icon}
          <Typography
            sx={{
              fontSize: 15,
              fontWeight: 600,
              lineHeight: 1.4,
              color: "#fff",
            }}
          >
            {view?.text}
          </Typography>
        </Box>
      </Slide>
    </Box>
  );
}